import styled from 'styled-components';

import ImageWithAlt from '~/shared/components/ImageWithAlt';
import warningImage from '~/shared/assets/warning.svg';
import {getLocalizationService} from '~/shared/services/localisationService';
import PieButton from '~/shared/theme/pie/PieButton';

const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px 0;
`;

const StyledImageWithAlt = styled(ImageWithAlt)`
  width: 200px;
  margin: 0 auto;
`;

const H1 = styled.h1`
  text-align: center;
  margin: 0;
  padding: 0;
  font-size: 24px;
  line-height: 32px;
`;

const StyledPieButton = styled(PieButton).attrs({variant: 'primarySmall'})`
  width: fit-content;
  margin: 0 auto;
  padding: 10px 24px;
`;

type OtlRulesFetchErrorProps = {
  onRetryClick: () => void | Promise<void>;
};

const OtlRulesFetchError = ({onRetryClick}: OtlRulesFetchErrorProps) => {
  const {t} = getLocalizationService();

  return (
    <Wrapper>
      <StyledImageWithAlt src={warningImage} alt={t('error')} />
      <H1 dangerouslySetInnerHTML={{__html: t('fetch_otl_rules_failed_title')}} />
      <StyledPieButton onClick={onRetryClick}>{t('try_again_3')}</StyledPieButton>
    </Wrapper>
  );
};

export default OtlRulesFetchError;
